export default __webpack_public_path__ + "static/media/262cc805feb4d7af5df11c376010ab32.svg";